"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const useEventListener_1 = __importDefault(require("../../../common/helpers/Hooks/useEventListener"));
const SearchContent_1 = __importDefault(require("./ClasicModals/SearchContent"));
const ModalGeneralWrapper = styled_components_1.default.div ``;
const ModalContent = styled_components_1.default.div `
  height: ${(props) => props.expandedHeight}px;
  width: ${(props) => props.expandedWidth}px;

  background-color: #fff;
`;
const SearchModal = ({ location }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [modalState, setModalState] = (0, react_1.useState)({});
    const [renderTrigger, setRenderTrigger] = (0, react_1.useState)(false);
    const windowWidth = (0, react_1.useRef)(window.innerWidth);
    const onClose = () => {
        setIsOpen(false);
    };
    const handleResize = () => {
        setRenderTrigger(!renderTrigger);
        if (windowWidth.current !== window.innerWidth) {
            windowWidth.current = window.innerWidth;
            onClose();
        }
    };
    (0, react_1.useEffect)(() => {
        const openModal = (event) => {
            setModalState(event.detail);
            setIsOpen(true);
        };
        window.addEventListener("openSearchModal", openModal);
        window.addEventListener("closeSearchModal", onClose);
        return () => {
            window.removeEventListener("openSearchModal", openModal);
            window.removeEventListener("closeSearchModal", onClose);
        };
    }, []);
    (0, useEventListener_1.default)("resize", () => {
        handleResize();
    });
    (0, react_1.useEffect)(() => {
        onClose();
    }, [location]);
    const modalSize = {
        height: window.innerHeight,
        width: window.innerWidth,
    };
    const { modalType, modalProps } = modalState || {};
    return (react_1.default.createElement(ModalGeneralWrapper, null,
        react_1.default.createElement(Dialog_1.default, { open: isOpen, onClose: onClose, fullScreen: true, PaperProps: {
                style: {
                    borderRadius: 0,
                    maxWidth: "none",
                },
            } },
            react_1.default.createElement(ModalContent, { expandedWidth: modalSize.width, expandedHeight: modalSize.height }, renderModal(modalType, modalProps, onClose)))));
};
function renderModal(type, props, onClose) {
    switch (type) {
        case modalEnums_1.default.SEARCH:
            return react_1.default.createElement(SearchContent_1.default, Object.assign({}, props, { onClose: onClose }));
        default:
            return false;
    }
}
exports.default = (0, react_router_dom_1.withRouter)(SearchModal);
